import { downloaduploadedDocumentsOnAPICall } from '../../../actions/utilAction';
import {
  actionCreator,
  checkHttpStatus,
  GETALL_ERA_CLAIMS,
  GET_EDI_GATEWAYS,
  GET_EDI835_FILE_API,
  BULK_DOWNLOAD_ERA_DETAILS,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
  ManageERAActionTypes,
  jsonApiHeader
} from '../constants/ApiConstants'

export const get_All_ERA_Claims = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ManageERAActionTypes.get_All_ERA_Claims.REQUEST));
    fetch(`${GETALL_ERA_CLAIMS}?ERADate=${searchObj.ERADate}&ClearinghouseName=${searchObj.ClearinghouseName}&CheckNumber=${searchObj.CheckNumber}&Payer=${searchObj.Payer}&Status=${searchObj.Status}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(ManageERAActionTypes.get_All_ERA_Claims.SUCCESS, response));
        } else {
          dispatch(actionCreator(ManageERAActionTypes.get_All_ERA_Claims.SUCCESS, null));
        }
      })
      .catch(function (error) {
        console.log('error action(clearing house) get_clearinghouseDetails --', error);
      });
  };


}

export const get_EDI_GateWays = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ManageERAActionTypes.get_EDI_GateWays.REQUEST));
    fetch(`${GET_EDI_GATEWAYS}?pageNumber=${searchObj.pageNumber}&pageSize=${searchObj.pageSize}&sortColumn=${searchObj.sortColumn}&sortOrder=${searchObj.sortOrder}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function (response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(ManageERAActionTypes.get_EDI_GateWays.SUCCESS, response));
        } else {
          dispatch(actionCreator(ManageERAActionTypes.get_EDI_GateWays.SUCCESS, null));
        }
      })
      .catch(function (error) {
        console.log('error action(clearing house) get_clearinghouseDetails --', error);
      });
  };
}

export const EDI835Download = (batchId, fileName) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ManageERAActionTypes.get_EDI835_File.REQUEST));
    fetch(`${GET_EDI835_FILE_API}?id=${batchId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(ManageERAActionTypes.get_EDI835_File.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      downloaduploadedDocumentsOnAPICall(blob, fileName);
    });
  };
};



export const bulk_Download_ERA_Details = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(ManageERAActionTypes.bULK_DOWNLOAD_ERA_DETAILS.REQUEST));
    fetch(`${BULK_DOWNLOAD_ERA_DETAILS}?ERADate=${searchObj.ERADate}&ClearinghouseName=${searchObj.ClearinghouseName}&CheckNumber=${searchObj.CheckNumber}&Payer=${searchObj.Payer}&Status=${searchObj.Status}&BatchId=${searchObj.BatchId}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    }).then(function(response) {
      dispatch(actionCreator(ManageERAActionTypes.bULK_DOWNLOAD_ERA_DETAILS.SUCCESS));
      return response.blob();
    }).then(function(blob) {
      downloaduploadedDocumentsOnAPICall(blob,"BULK_ERA_DETAILS");
    });
  };
};





// WEBPACK FOOTER //
// ./src/modules/ManageERA/actions/manageEraActions.js